import { FormInstance } from "sunday-component/node_modules/antd";
import { some } from "lodash";
import { isMobile } from "src/utils/deviceDetector";
import { DATE_INPUT_TEXT_FORMAT } from "src/constants/format";
import dayjs, { Dayjs } from "dayjs";
import {
  DATE_PICKER_DATE_FORMAT,
  isAfterDate,
  isBeforeDate,
  isToday,
} from "../../../utils/date";
import { CustomDatePicker, DatePickerGlobalStyle } from "./DatePicker.styled";

export interface DatePickerInputProp {
  value?: Date | Dayjs | string;
  form?: FormInstance;
  dataTestId?: string;
  format?: string;
  placeholder?: string;
  disabledPast?: boolean;
  disabledToday?: boolean;
  disabledFuture?: boolean;
  disabled?: boolean;
  allowClear?: boolean;
  onChange?: (value: Dayjs) => void;
  disabledDate?: (value: Date) => boolean;
  defaultPickerValue?: Date | Dayjs | string;
  className?: string;
  style?: object;
  showBuddhistEra?: boolean;
}

export const defaultDisabledDate =
  ({ disabledPast, disabledToday, disabledFuture }) =>
  (date) =>
    some([
      disabledPast && isBeforeDate(date),
      disabledToday && isToday(date),
      disabledFuture && isAfterDate(date),
    ]);

const DatePicker = ({
  value,
  form,
  format = DATE_PICKER_DATE_FORMAT,
  dataTestId,
  placeholder,
  disabledPast,
  disabledToday,
  disabledFuture,
  disabled = false,
  allowClear = false,
  onChange,
  disabledDate,
  defaultPickerValue,
  className,
  showBuddhistEra = true,
  ...props
}: DatePickerInputProp) => (
  <>
    <DatePickerGlobalStyle />
    <CustomDatePicker
      value={(value as any as string) || (defaultPickerValue as any as string)}
      {...(defaultPickerValue
        ? ({ openToDate: dayjs(defaultPickerValue).toDate() } as any)
        : {})}
      data-testid={dataTestId}
      data-gtm-input-code={dataTestId}
      format={format}
      placeholder={placeholder}
      disabled={disabled}
      filterDates={
        disabledDate
          ? (v) => !disabledDate(v)
          : (v) =>
              !defaultDisabledDate({
                disabledPast,
                disabledToday,
                disabledFuture,
              })(v)
      }
      showBuddhistEra={showBuddhistEra}
      onChange={(v) => onChange(dayjs(v, DATE_INPUT_TEXT_FORMAT))}
      className={className}
      {...{ autocomplete: "off" }} // Dev-note: This is work around for prevent lint error because component dont provide this prop.
      {...(isMobile ? { onFocus: (e) => e.target.blur() } : {})} // Dev-note: This is work around for disable keyboard on mobile device.
      {...props}
    />
  </>
);

export default DatePicker;
